import { render, staticRenderFns } from "./Disable2FA.vue?vue&type=template&id=5f3a0e7e&scoped=true"
import script from "./Disable2FA.vue?vue&type=script&lang=js"
export * from "./Disable2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3a0e7e",
  null
  
)

export default component.exports